import { Tooltip, TooltipProps, tooltipClasses } from "@mui/material";
import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { styled } from "@mui/system";

// TypeScript version of useStyles
const useStyles = makeStyles((theme: Theme) => ({
  topBorder: {
    borderTop: `2px solid ${theme.palette.gray40.main}`,
  },
  backgroundColor: {
    backgroundColor: theme.palette.gray20.main,
    borderBottomLeftRadius: "4px",
    borderBottomRightRadius: "4px",
  },
}));

// Styled CustomTooltip component with typed props
export const CustomTooltip = styled(
  ({ className, ...props }: TooltipProps & { className?: string }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ),
)(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#212121",
    color: "#FFFFFF",
    maxWidth: "400px",
    fontSize: "16px",
  },
}));

export default useStyles;
